import { useState, useRef, useMemo, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";

const IndividualInvestment = ({ person_id }) => { 
    const BaseUrl = process.env.REACT_APP_API;
    const [portfolioData, setPortfolioData] = useState([]);

    useEffect(() => {
        const fetchPortfolioData = async () => {
          try {
        
            const token = sessionStorage.getItem('AuthToken');
            const response = await axios.get(`${BaseUrl}/getIndividualInvestmentsByID`, {
              params: {
                person_id: person_id,
              },
              headers: {
                Authorization: `Bearer ${token}`, // Added token for authentication
                "Content-Type": "application/json",
              },
            });
      
            if (response.status !== 200) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
      
            const data = response.data;
      
            if (Array.isArray(data)) {
              // Sort data by investment date
              const sortedData = data.sort(
                (a, b) => new Date(a.DateOfInvestment) - new Date(b.DateOfInvestment)
              );
              setPortfolioData(sortedData);
      
              // Calculate total invested value
              const currentValue = sortedData.reduce(
                (sum, item) =>
                  sum + parseFloat(item.nav_quantity || 0) * parseFloat(item.nav_price || 0),
                0
              );
      
              // Calculate total current value
              const totalInvested = sortedData.reduce(
                (sum, item) => sum + parseFloat(item.nav_quantity || 0),
                0
              );
      
              // Total number of investments
              const totalInvestments = sortedData.length;
      
              // Number of unique asset groups
              const investmentGroups = new Set(
                sortedData.map((item) => item.AssetClassID)
              ).size;
      
            } else {
              console.error("Data is not an array:", data);
            }
          } catch (error) {
            console.error("Error fetching portfolio data:", error);
          }
        };
      
          fetchPortfolioData();
      
      
        // eslint-disable-next-line
      }, [BaseUrl, person_id]);
      
     

  return (
    <>

      <div className="page-content">
      <div className="table-responsive mt-3">
      {portfolioData.length === 0 ? (
        <div className="text-center">
          <h6>No investments found.</h6>
        </div>
      ) : (
        <>
        <h6>Investment Details</h6>
        <Table className="table table-hover table-centered mb-0">
          <thead className="thead-light">
            <tr>
              <th>#</th>
              <th>Quantity</th>
              <th>NAV Price</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {portfolioData.map((item, index) => (
              <tr key={item.id}>
                <th scope="row">{index + 1}</th>
                <td>{item.nav_quantity.toFixed(2)}</td>
                <td>{"$" + item.nav_price.toFixed(2)}</td>
                <td>{"$"  + (item.amount).toFixed(2)}</td>
                <td>{new Date(item.nav_date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </>
      )}
    </div>
      </div>
    </>
  );
};

export default IndividualInvestment;